import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import rehypeSanitize from 'rehype-sanitize';
import remarkBreaks from 'remark-breaks';

const REMARK_PLUGINS = [remarkBreaks];
// Order matters: parse the raw HTML into the tree first, then sanitise the whole tree.
const HTML_REHYPE_PLUGINS = [rehypeRaw, rehypeSanitize];

/**
 * Markdown for user-written text (note bodies, RELAY-945; task descriptions, TS-1740).
 * Links open in a new tab without handing the opener over. A single newline is a line break
 * (`remark-breaks`), because people type lines, not paragraphs.
 *
 * Raw HTML: by default it is never rendered (a `<script>` shows as text). With `html` (notes,
 * which may be written or pasted as HTML — RecruitCRM's notes are HTML — as well as Markdown)
 * it is parsed (`rehype-raw`) and then SANITISED (`rehype-sanitize`, GitHub's allowlist):
 * formatting, lists, tables, links and images stay; `script`, `style`, `iframe`, `on*`
 * handlers, `style` attributes and `javascript:` URLs are removed. Never add `rehypeRaw`
 * without the sanitiser after it — a note would then run its own markup in every viewer's
 * browser.
 */
export function Markdown({ children, html }: { children: string; html?: boolean | undefined }) {
  return (
    <div className="text-sm leading-relaxed [&_a]:text-brand [&_a]:underline [&_ol]:list-decimal [&_ol]:pl-5 [&_p]:my-1 [&_ul]:list-disc [&_ul]:pl-5 [&_code]:bg-surface [&_code]:rounded [&_code]:px-1 [&_table]:my-1 [&_td]:border [&_td]:px-2 [&_th]:border [&_th]:px-2 [&_img]:max-w-full break-words">
      <ReactMarkdown
        remarkPlugins={REMARK_PLUGINS}
        rehypePlugins={html ? HTML_REHYPE_PLUGINS : undefined}
        components={{
          a: ({ href, children: c }) => (
            <a href={href} target="_blank" rel="noopener noreferrer">
              {c}
            </a>
          ),
        }}
      >
        {children}
      </ReactMarkdown>
    </div>
  );
}
